/**
 * Utility function for safe date formatting
 * Prevents "Invalid time value" errors
 */
import { format } from 'date-fns';

export const safeFormatDate = (dateValue, formatString = 'dd/MM/yyyy HH:mm') => {
  if (!dateValue) return 'Date non disponible';
  
  try {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) {
      return 'Date invalide';
    }
    return format(date, formatString);
  } catch (error) {
    console.error('Error formatting date:', error, dateValue);
    return 'Date invalide';
  }
};

export const isValidDate = (dateValue) => {
  if (!dateValue) return false;
  
  try {
    const date = new Date(dateValue);
    return !isNaN(date.getTime());
  } catch (error) {
    return false;
  }
};
